"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORPORATION_INFO_CREATE_GROUPS = void 0;
const ECorporationResourceGroups_1 = require("./ECorporationResourceGroups");
exports.CORPORATION_INFO_CREATE_GROUPS = [
    ECorporationResourceGroups_1.ECorporationResourceGroups.raisonSociale,
    ECorporationResourceGroups_1.ECorporationResourceGroups.siret,
    ECorporationResourceGroups_1.ECorporationResourceGroups.formeJuridique,
    ECorporationResourceGroups_1.ECorporationResourceGroups.siegeSocial,
    ECorporationResourceGroups_1.ECorporationResourceGroups.residenceFiscale,
    ECorporationResourceGroups_1.ECorporationResourceGroups.residenceFiscaleAutre,
    ECorporationResourceGroups_1.ECorporationResourceGroups.regimeFiscal,
    ECorporationResourceGroups_1.ECorporationResourceGroups.assujettiIFI,
];
